import { render, staticRenderFns } from "./userModalUpdates.vue?vue&type=template&id=18fa4242&scoped=true&"
import script from "./userModalUpdates.vue?vue&type=script&lang=js&"
export * from "./userModalUpdates.vue?vue&type=script&lang=js&"
import style0 from "./userModalUpdates.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./userModalUpdates.vue?vue&type=style&index=1&id=18fa4242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa4242",
  null
  
)

export default component.exports